import { gql } from '@apollo/client';
import { SortingCrossBorderOnline24hDetailDownloadFilterInput } from '../../types/dashboard/SortingCrossBorderOnline24hDetailTypes';

export const GENERATE_SORTING_CROSS_BORDER_ONLINE_24H_DETAIL_DOWNLOAD_REPORT = gql`
    mutation GenerateSortingCrossBorderOnline24hDetailDownloadReport(
        $filter: SortingCrossBorderOnline24hDetailDownloadFilterInput!
        $timezone: String
    ) {
        generateSortingCrossBorderOnline24hDetailDownloadReport(filter: $filter, timezone: $timezone)
    }
`;

export interface GenerateSortingCrossBorderOnline24hDetailDownloadReportVariables {
    filter: SortingCrossBorderOnline24hDetailDownloadFilterInput;
    timezone?: string;
}

export interface GenerateSortingCrossBorderOnline24hDetailDownloadReportResponse {
    generateSortingCrossBorderOnline24hDetailDownloadReport: string;
}
